import { render, staticRenderFns } from "./Funding.vue?vue&type=template&id=a4847f44&scoped=true&"
import script from "./Funding.vue?vue&type=script&lang=js&"
export * from "./Funding.vue?vue&type=script&lang=js&"
import style0 from "./Funding.vue?vue&type=style&index=0&id=a4847f44&prod&lang=scss&"
import style1 from "./Funding.vue?vue&type=style&index=1&id=a4847f44&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4847f44",
  null
  
)

export default component.exports